// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — signal.styled.classic.js, новая — signal.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './signal.styled.classic';
import * as cp from './signal.styled.cp';

export const Cell = isCp ? cp.Cell : classic.Cell;
export const Row = isCp ? cp.Row : classic.Row;
export const Submit = isCp ? cp.Submit : classic.Submit;
